// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"285":"09cbb9b1","384":"0a9af8bd"}[chunkId] + ".chunk.js";
};